const stringifyUnknownValueInternal = (
  value: unknown,
  seenObjects: WeakSet<object>,
): string => {
  if (value === null) {
    return "null"
  }
  if (value === undefined) {
    return "undefined"
  }
  if (typeof value === "string") {
    return value
  }
  if (
    typeof value === "number" ||
    typeof value === "boolean" ||
    typeof value === "bigint"
  ) {
    return String(value)
  }
  if (typeof value === "symbol" || typeof value === "function") {
    return value.toString()
  }
  if (Array.isArray(value)) {
    if (seenObjects.has(value)) {
      return "[Circular]"
    }

    seenObjects.add(value)
    const renderedValue = value
      .map((item) => stringifyUnknownValueInternal(item, seenObjects))
      .join(",")
    seenObjects.delete(value)

    return renderedValue
  }
  if (
    value instanceof Date ||
    value instanceof RegExp ||
    value instanceof Error
  ) {
    return value.toString()
  }

  try {
    return JSON.stringify(value)
  } catch {
    return "[object Object]"
  }
}

export const stringifyUnknownValue = (value: unknown): string => {
  return stringifyUnknownValueInternal(value, new WeakSet<object>())
}
